import { useEffect, useRef } from 'react';
import { LoadingScreen } from '../../../components/loading-screen';
import type { DashboardPageProps } from '../../../lib/dashboard-page';

type RedirectPageProps = {
  isPartner: boolean;
  /** `currentTeam.slugged_name`, used for the partner path when `siteId` isn't set. */
  partnerSiteId: string;
  siteId: string;
  siteEnv: string;
};

export function RedirectPage({
  handlers,
  pageProps = { isPartner: false, partnerSiteId: '', siteId: '', siteEnv: '' },
}: DashboardPageProps<RedirectPageProps>) {
  const { navigationHandler } = handlers;
  const { isPartner, partnerSiteId, siteId, siteEnv } = pageProps;
  const hasRun = useRef<boolean>(false);

  useEffect(() => {
    if (hasRun.current) return;
    hasRun.current = true;

    const query = navigationHandler.query();

    if (isPartner) {
      navigationHandler.navigate(`/${partnerSiteId}/partners/overview`, {
        excludeSiteId: true,
        excludeSiteEnv: true,
        query,
      });
      return;
    }

    navigationHandler.navigate(`/${siteId}/${siteEnv}`, {
      excludeSiteId: true,
      excludeSiteEnv: true,
      query,
    });
  }, [navigationHandler, isPartner, partnerSiteId, siteId, siteEnv]);

  return <LoadingScreen />;
}
